import { render, staticRenderFns } from "./MainHolder.vue?vue&type=template&id=55f364a7&scoped=true&"
import script from "./MainHolder.vue?vue&type=script&lang=js&"
export * from "./MainHolder.vue?vue&type=script&lang=js&"
import style0 from "./MainHolder.vue?vue&type=style&index=0&id=55f364a7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f364a7",
  null
  
)

export default component.exports